webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = exports.lang = exports.getParam = exports.eachLines = exports.transform = exports.maxPoint = exports.lastRecord = exports.StorageKey = exports.clearPoints = exports.blankMatrix = exports.blankLine = exports.fillLine = exports.delays = exports.speeds = exports.blockType = exports.origin = exports.blockShape = undefined;

var _keys = __webpack_require__(14);

var _keys2 = _interopRequireDefault(_keys);

var _i18n = __webpack_require__(142);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockShape = exports.blockShape = {
  I: [[1, 1, 1, 1]],
  L: [[0, 0, 1], [1, 1, 1]],
  J: [[1, 0, 0], [1, 1, 1]],
  Z: [[1, 1, 0], [0, 1, 1]],
  S: [[0, 1, 1], [1, 1, 0]],
  O: [[1, 1], [1, 1]],
  T: [[0, 1, 0], [1, 1, 1]]
};

var origin = exports.origin = {
  I: [[-1, 1], [1, -1]],
  L: [[0, 0]],
  J: [[0, 0]],
  Z: [[0, 0]],
  S: [[0, 0]],
  O: [[0, 0]],
  T: [[0, 0], [1, 0], [-1, 1], [0, -1]]
};

var blockType = exports.blockType = (0, _keys2.default)(blockShape);

var speeds = exports.speeds = [800, 650, 500, 370, 250, 160];

var delays = exports.delays = [50, 60, 70, 80, 90, 100];

var fillLine = exports.fillLine = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];

var blankLine = exports.blankLine = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

var blankMatrix = exports.blankMatrix = function () {
  var matrix = [];
  for (var i = 0; i < 20; i++) {
    matrix.push(blankLine);
  }
  return matrix;
}();

var clearPoints = exports.clearPoints = [100, 300, 700, 1500];

var StorageKey = exports.StorageKey = 'VUE_TETRIS';

var lastRecord = exports.lastRecord = function () {
  var data = window.localStorage.getItem(StorageKey);
  if (!data) {
    return false;
  }
  try {
    if (window.btoa) {
      data = atob(data);
    }
    data = decodeURIComponent(data);
    data = JSON.parse(data);
  } catch (e) {
    if (window.console || window.console.error) {
      window.console.error('读取记录错误:', e);
    }
    return false;
  }
  return data;
}();

var maxPoint = exports.maxPoint = 999999;

var transform = exports.transform = function () {
  var trans = ['transform', 'webkitTransform', 'msTransform', 'mozTransform', 'oTransform'];
  var body = document.body;
  return trans.filter(function (e) {
    return body.style[e] !== undefined;
  })[0];
}();

var eachLines = exports.eachLines = 20;var getParam = exports.getParam = function getParam(param) {
  var r = new RegExp('\\?(?:.+&)?' + param + '=(.*?)(?:&.*)?$');
  var m = window.location.toString().match(r);
  return m ? decodeURI(m[1]) : '';
};

var lang = exports.lang = function () {
  var l = getParam('lang').toLowerCase();
  if (!l && navigator.languages) {
    l = navigator.languages.find(function (l) {
      return _i18n2.default.lang.indexOf(l) !== -1;
    });
  }
  l = _i18n2.default.lang.indexOf(l) === -1 ? _i18n2.default.default : l;
  return l;
}();

document.title = _i18n2.default.data.title[lang];

var i18n = exports.i18n = _i18n2.default.data;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFocus = exports.visibilityChangeEvent = exports.subscribeRecord = exports.isOver = exports.isClear = exports.want = exports.isMobile = exports.getNextType = undefined;

var _stringify = __webpack_require__(9);

var _stringify2 = _interopRequireDefault(_stringify);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hiddenProperty = function () {
  var names = ['hidden', 'webkitHidden', 'mozHidden', 'msHidden'];
  names = names.filter(function (e) {
    return e in document;
  });
  return names.length > 0 ? names[0] : false;
}();
var unit = {
  getNextType: function getNextType() {
    var len = _const.blockType.length;
    return _const.blockType[Math.floor(Math.random() * len)];
  },
  want: function want(next, matrix) {
    var xy = next.xy;
    var shape = next.shape;
    var horizontal = shape[0].length;
    return shape.every(function (m, k1) {
      return m.every(function (n, k2) {
        if (xy[1] < 0) {
          return false;
        }
        if (xy[1] + horizontal > 10) {
          return false;
        }
        if (xy[0] + k1 < 0) {
          return true;
        }
        if (xy[0] + k1 >= 20) {
          return false;
        }
        if (n) {
          if (matrix[xy[0] + k1][xy[1] + k2]) {
            return false;
          }
          return true;
        }
        return true;
      });
    });
  },
  isClear: function isClear(matrix) {
    var clearLines = [];
    matrix.forEach(function (m, k) {
      if (m.every(function (n) {
        return !!n;
      })) {
        clearLines.push(k);
      }
    });
    if (clearLines.length === 0) {
      return false;
    }
    return clearLines;
  },
  isOver: function isOver(matrix) {

    return matrix[0].some(function (n) {
      return !!n;
    });
  },
  subscribeRecord: function subscribeRecord(store) {
    store.subscribe(function () {
      var data = store.state;
      if (data.lock) {
        return;
      }
      data = (0, _stringify2.default)(data);
      data = encodeURIComponent(data);
      if (window.btoa) {
        data = btoa(data);
      }
      window.localStorage.setItem(_const.StorageKey, data);
    });
  },
  isMobile: function isMobile() {
    var ua = navigator.userAgent;
    var android = /Android (\d+\.\d+)/.test(ua);
    var iphone = ua.indexOf('iPhone') > -1;
    var ipod = ua.indexOf('iPod') > -1;
    var ipad = ua.indexOf('iPad') > -1;
    var nokiaN = ua.indexOf('NokiaN') > -1;
    return android || iphone || ipod || ipad || nokiaN;
  },

  visibilityChangeEvent: function () {
    if (!hiddenProperty) {
      return false;
    }
    return hiddenProperty.replace(/hidden/i, 'visibilitychange');
  }(),
  isFocus: funct./static/qr.png';
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.resize.bind(this), true);
  },

  methods: {
    resize: function resize() {
      this.isMobile = (0, _unit.isMobile)();
    }
  }
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

exports.default = {
  props: ['active', 'color', 'size', 'top', 'left', 'label', 'position', 'arrow']
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(14);

var _keys2 = _interopRequireDefault(_keys);

var _index = __webpack_require__(121);

var _index2 = _interopRequireDefault(_index);

var _const = __webpack_require__(0);

var _store = __webpack_require__(8);

var _store2 = _interopRequireDefault(_store);

var _todo = __webpack_require__(29);

var _todo2 = _interopRequireDefault(_todo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['filling'],
  data: function data() {
    return {
      fillingNum: 0
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.fillingNum = nextProps.filling + 20;
      }
    }
  },
  computed: {
    keyboard: function keyboard() {
      return this.$store.state.keyboard;
    },

    rotation: function rotation() {
      return _const.i18n.rotation[_const.lang];
    },
    labelLeft: function labelLeft() {
      return _const.i18n.left[_const.lang];
    },
    labelRight: function labelRight() {
      return _const.i18n.right[_const.lang];
    },
    labelDown: function labelDown() {
      return _const.i18n.down[_const.lang];
    },
    labelDropSpace: function labelDropSpace() {
      return _const.i18n.drop[_const.lang] + ' (SPACE)';
    },
    labelResetR: function labelResetR() {
      return _const.i18n.reset[_const.lang] + '(R)';
    },
    labelSoundS: function labelSoundS() {
      return _const.i18n.sound[_const.lang] + '(S)';
    },
    labelPauseP: function labelPauseP() {
      return _const.i18n.pause[_const.lang] + '(P)';
    }
  },
  mounted: function mounted() {
    var _this = this;

    var touchEventCatch = {};
    var mouseDownEventCatch = {};
    document.addEventListener('touchstart', function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
    }, true);
    document.addEventListener('touchend', function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
    }, true);

    document.addEventListener('gesturestart', function (event) {
      event.preventDefault();
    });

    document.addEventListener('mousedown', function (e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
    }, true);
    (0, _keys2.default)(_todo2.default).forEach(function (key) {
      _this.$refs['dom_' + key].$el.addEventListener('mousedown', function () {
        if (touchEventCatch[key] === true) {
          return;
        }
        _todo2.default[key].down(_store2.default);
        mouseDownEventCatch[key] = true;
      }, true);
      _this.$refs['dom_' + key].$el.addEventListener('mouseup', function () {
        if (touchEventCatch[key] === true) {
          touchEventCatch[key] = false;
          return;
        }
        _todo2.default[key].up(_store2.default);
        mouseDownEventCatch[key] = false;
      }, true);
      _this.$refs['dom_' + key].$el.addEventListener('mouseout', function () {
        if (mouseDownEventCatch[key] === true) {
          _todo2.default[key].up(_store2.default);
        }
      }, true);
      _this.$refs['dom_' + key].$el.addEventListener('touchstart', function () {
        touchEventCatch[key] = true;
        _todo2.default[key].down(_store2.default);
      }, true);
      _this.$refs['dom_' + key].$el.addEventListener('touchend', function () {
        _todo2.default[key].up(_store2.default);
      }, true);
    });
  },

  components: {
    Vbutton: _index2.default
  }
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

var Logo = {
  timeout: null
};
exports.default = {
  props: ['cur', 'reset'],
  data: function data() {
    return {
      style: 'r1',
      display: 'none'
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps, oldProps) {
        this.animate(nextProps);
        if ([oldProps.cur, nextProps.cur].indexOf(false) !== -1 && oldProps.cur !== nextProps.cur || oldProps.reset !== nextProps.reset) {
          this.animate(nextProps);
        }
      }
    }
  },
  computed: {
    titleCenter: function titleCenter() {
      return _const.i18n.titleCenter[_const.lang];
    }
  },
  beforeMount: function beforeMount() {
    this.animate(this.$props);
  },

  methods: {
    animate: function animate(_ref) {
      var _this = this;

      var cur = _ref.cur,
          reset = _ref.reset;

      clearTimeout(Logo.timeout);
      this.style = 'r1';
      this.display = 'none';
      if (cur || reset) {
        this.display = 'none';
        return;
      }

      var m = 'r';
      var count = 0;

      var set = function set(func, delay) {
        if (!func) {
          return;
        }
        Logo.timeout = setTimeout(func, delay);
      };

      var show = function show(func) {
        set(function () {
          _this.display = 'block';
          if (func) {
            func();
          }
        }, 150);
      };

      var hide = function hide(func) {
        set(function () {
          _this.display = 'none';
          if (func) {
            func();
          }
        }, 150);
      };

      var eyes = function eyes(func, delay1, delay2) {
        set(function () {
          _this.style = m + 2;
          set(function () {
            _this.style = m + 1;
            if (func) {
              func();
            }
          }, delay2);
        }, delay1);
      };

      var run = function run(func) {
        set(function () {
          _this.style = m + 4;
          set(function () {
            _this.style = m + 3;
            count++;
            if (count === 10 || count === 20 || count === 30) {
              m = m === 'r' ? 'l' : 'r';
            }
            if (count < 40) {
              run(func);
              return;
            }
            _this.style = m + 1;
            if (func) {
              set(func, 4000);
            }
          }, 100);
        }, 100);
      };

      var dra = function dra() {
        count = 0;
        eyes(function () {
          eyes(function () {
            eyes(function () {
              _this.style = m + 2;
              run(dra);
            }, 150, 150);
          }, 150, 150);
        }, 1000, 1500);
      };

      show(function () {
        hide(function () {
          show(function () {
            hide(function () {
              show(function () {
                dra();
              });
            });
          });
        });
      });
    }
  }
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(9);

var _stringify2 = _interopRequireDefault(_stringify);

var _unit = __webpack_require__(1);

var _const = __webpack_require__(0);

var _states = __webpack_require__(3);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var t = setTimeout;
exports.default = {
  props: ['cur', 'reset', 'propMatrix'],
  watch: {
    $props: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var oldVal = arguments[1];

        this.propsChange(val);
      },

      deep: true
    }
  },
  render: function render() {
    var h = arguments[0];

    var matrix = void 0;
    if (this.isOver) {
      matrix = this.overState;
    } else {
      matrix = this.getResult();
    }

    return h(
      'div',
      { 'class': 'matrix' },
      [matrix.map(function (p, k1) {
        return h(
          'p',
          null,
          [p.map(function (e, k2) {
            return h(
              'b',
              { 'class': (e === 1 ? 'c' : '') + (e === 2 ? 'd' : '') },
              []
            );
          })]
        );
      })]
    );
  },
  data: function data() {
    return {
      clearLines: false,
      animateColor: 2,
      isOver: false,
      overState: null
    };
  },

  methods: {
    propsChange: function propsChange(nextProps) {
      var _this = this;

      var clears = (0, _unit.isClear)(nextProps.propMatrix);
      var overs = nextProps.reset;
      setTimeout(function () {
        _this.clearLines = clears;
        _this.isOver = overs;
      }, 0);
      if (clears && !this.clearLines) {
        this.clearAnimate(clears);
      }
      if (!clears && overs && !this.isOver) {
        this.over(nextProps);
      }
    },
    getResult: function getResult(props) {
      if (!props) {
        props = this.$props;
      }
      var cur = props.cur;
      var shape = cur && cur.shape;
      var xy = cur && cur.xy;
      var matrix = JSON.parse((0, _stringify2.default)(props.propMatrix));
      var clearLines = this.clearLines;
      if (clearLines) {
        var animateColor = this.animateColor;
        clearLines.forEach(function (index) {
          matrix[index] = [animateColor, animateColor, animateColor, animateColor, animateColor, animateColor, animateColor, animateColor, animateColor, animateColor];
        });
      } else if (shape) {
        shape.forEach(function (m, k1) {
          return m.forEach(function (n, k2) {
            if (n && xy[0] + k1 >= 0) {
              var line = matrix[xy[0] + k1];
              var color = void 0;
              if (line[xy[1] + k2] === 1 && !clearLines) {
                color = 2;
              } else {
                color = 1;
              }
              line[xy[1] + k2] = color;
              matrix[xy[0] + k1] = line;
            }
          });
        });
      }
      return matrix;
    },
    clearAnimate: function clearAnimate() {
      var _this2 = this;

      var anima = function anima(callback) {
        t(function () {
          _this2.animateColor = 0;
          t(function () {
            _this2.animateColor = 2;
            if (typeof callback === 'function') {
              callback();
            }
          }, 100);
        }, 100);
      };
      anima(function () {
        anima(function () {
          anima(function () {
            t(function () {
              _states2.default.clearLines(_this2.propMatrix, _this2.clearLines);
            }, 100);
          });
        });
      });
    },
    over: function over(nextProps) {
      var _this3 = this;

      var overState = this.getResult(nextProps);

      this.overState = [].concat((0, _toConsumableArray3.default)(overState));
      var exLine = function exLine(index) {
        if (index <= 19) {
          overState[19 - index] = _const.fillLine;
        } else if (index >= 20 && index <= 39) {
          overState[index - 20] = _const.blankLine;
        } else {
          _states2.default.overEnd();
          return;
        }
        _this3.overState = [].concat((0, _toConsumableArray3.default)(overState));
      };

      for (var i = 0; i <= 40; i++) {
        t(exLine.bind(null, i), 40 * (i + 1));
      }
    }
  }
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['data']
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(20);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _const = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var xy = {
  I: [1, 0],
  L: [0, 0],
  J: [0, 0],
  Z: [0, 0],
  S: [0, 0],
  O: [0, 1],
  T: [0, 0]
};
var empty = [[0, 0, 0, 0], [0, 0, 0, 0]];

exports.default = {
  props: ['data'],
  mounted: function mounted() {
    this.build(this.data);
  },
  data: function data() {
    return {
      block: empty
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.build(nextProps.data);
      }
    }
  },
  methods: {
    build: function build(type) {
      var shape = _const.blockShape[type];
      var block = empty.map(function (e) {
        return [].concat((0, _toConsumableArray3.default)(e));
      });
      shape.forEach(function (m, k1) {
        m.forEach(function (n, k2) {
          if (n) {
            block[k1 + xy[type][0]][k2 + xy[type][1]] = 1;
          }
        });
      });
      this.block = block;
    }
  }
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var formate = function formate(num) {
  return num < 10 ? ('0' + num).split('') : ('' + num).split('');
};
var NumberObj = {
  timeInterval: null,
  time_count: null
};
exports.default = {
  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.render();
      }
    }
  },
  props: {
    propTime: {
      type: Boolean
    },
    number: {
      type: Number
    },
    length: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      time_count: '',
      time: new Date(),
      data: []
    };
  },
  destroyed: function destroyed() {
    if (!this.propTime) {
      return;
    }
    clearTimeout(NumberObj.timeInterval);
  },

  methods: {
    render: function render() {
      if (this.propTime) {
        var now = this.time;
        var hour = formate(now.getHours());
        var min = formate(now.getMinutes());
        var sec = now.getSeconds() % 2;
        var t = hour.concat(sec ? 'd' : 'd_c', min);
        this.data = t;
        return;
      }
      var num = ('' + this.number).split('');
      for (var i = 0, len = this.length - num.length; i < len; i++) {
        num.unshift('n');
      }
      this.data = num;
      return;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.length) {
      this.length = 6;
    }
    if (!this.propTime) {
      return;
    }
    var clock = function clock() {
      var count = +NumberObj.timeInterval;
      NumberObj.timeInterval = setTimeout(function () {
        _this.time = new Date();
        _this.time_count = count;
        _this.render();
        clock();
      }, 1000);
    };
    clock();
  },
  mounted: function mounted() {
    this.render();
  }
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Pause = {
  timeout: null
};
exports.default = {
  props: ['data'],
  mounted: function mounted() {
    this.setShake(this.data);
  },
  data: function data() {
    return {
      showPause: false
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.setShake(nextProps.data);
      }
    }
  },
  methods: {
    setShake: function setShake(bool) {
      var _this = this;

      if (bool && !Pause.timeout) {
        Pause.timeout = setInterval(function () {
          _this.showPause = !_this.showPause;
        }, 250);
      }
      if (!bool && Pause.timeout) {
        clearInterval(Pause.timeout);
        this.showPause = false;
        Pause.timeout = null;
      }
    }
  }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(0);

var _index = __webpack_require__(41);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DF = _const.i18n.point[_const.lang];
var ZDF = _const.i18n.highestScore[_const.lang];
var SLDF = _const.i18n.lastRound[_const.lang];
var Point = {
  timeout: null
};
exports.default = {
  props: ['cur', 'point', 'max'],
  mounted: function mounted() {
    this.onChange(this.$props);
  },

  components: {
    Number: _index2.default
  },
  data: function data() {
    return {
      label: '',
      number: 0
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler(nextProps) {
        this.onChange(nextProps);
      }
    }
  },
  methods: {
    onChange: function onChange(_ref) {
      var _this = this;

      var cur = _ref.cur,
          point = _ref.point,
          max = _ref.max;

      clearInterval(Point.timeout);
      if (cur) {
        this.label = point >= max ? ZDF : DF;
        this.number = point;
      } else {
        var toggle = function toggle() {
          _this.label = SLDF;
          _this.number = point;
          Point.timeout = setTimeout(function () {
            _this.label = ZDF;
            _this.number = max;
            Point.timeout = setTimeout(toggle, 3000);
          }, 3000);
        };

        if (point !== 0) {
          toggle();
        } else {
          this.label = ZDF;
          this.number = max;
        }
      }
    }
  }
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(9);

var _stringify2 = _interopRequireDefault(_stringify);

var _unit = __webpack_require__(1);

var _event = __webpack_require__(4);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(3);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit("key_down", true);
  if (store.state.cur !== null) {
    _event2.default.down({
      key: "down",
      begin: 40,
      interval: 40,
      callback: function callback(stopDownTrigger) {
        var state = store.state;
        if (state.lock) {
          return;
        }
        if (_music.music.move) {
          _music.music.move();
        }
        var cur = state.cur;
        if (cur === null) {
          return;
        }
        if (state.pause) {
          _states2.default.pause(false);
          return;
        }
        var next = cur.fall();
        if ((0, _unit.want)(next, state.matrix)) {
          store.commit("moveBlock", next);

          _states2.default.auto();
        } else {
          var matrix = JSON.parse((0, _stringify2.default)(state.matrix));
          var shape = cur.shape;
          var xy = cur.xy;
          shape.forEach(function (m, k1) {
            return m.forEach(function (n, k2) {
              if (n && xy[0] + k1 >= 0) {
                var line = matrix[xy[0] + k1];
                line[xy[1] + k2] = 1;

                matrix[xy[0] + k1] = line;
              }
            });
          });
          _states2.default.nextAround(matrix, stopDownTrigger);
        }
      }
    });
  } else {
    _event2.default.down({
      key: "down",
      begin: 200,
      interval: 100,
      callback: function callback() {
        if (store.state.lock) {
          return;
        }
        var state = store.state;
        var cur = state.cur;
        if (cur) {
          return;
        }
        if (_music.music.move) {
          _music.music.move();
        }
        var startLines = state.startLines;
        startLines = startLines - 1 < 0 ? 10 : startLines - 1;
        store.commit("startLines", startLines);
      }
    });
  }
};

var up = function up(store) {
  store.commit("key_down", false);
  _event2.default.up({
    key: "down"
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unit = __webpack_require__(1);

var _event = __webpack_require__(4);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(3);

var _states2 = _interopRequireDefault(_states);

var _const = __webpack_require__(0);

var _music = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_left', true);
  _event2.default.down({
    key: 'left',
    begin: 200,
    interval: 100,
    callback: function callback() {
      var state = store.state;
      if (state.lock) {
        return;
      }
      if (_music.music.move) {
        _music.music.move();
      }
      var cur = state.cur;
      if (cur !== null) {
        if (state.pause) {
          _states2.default.pause(false);
          return;
        }
        var next = cur.left();
        var delay = _const.delays[state.speedRun - 1];
        var timeStamp = void 0;
        if ((0, _unit.want)(next, state.matrix)) {
          next.timeStamp += parseInt(delay, 10);
          store.commit('moveBlock', next);
          timeStamp = next.timeStamp;
        } else {
          cur.timeStamp += parseInt(parseInt(delay, 10) / 1.5, 10);
          store.commit('moveBlock', cur);
          timeStamp = cur.timeStamp;
        }
        var remain = _const.speeds[state.speedRun - 1] - (Date.now() - timeStamp);
        _states2.default.auto(remain);
      } else {
        var speed = state.speedStart;
        speed = speed - 1 < 1 ? 6 : speed - 1;
        store.commit('speedStart', speed);
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_left', false);
  _event2.default.up({
    key: 'left'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = __webpack_require__(4);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(3);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_pause', true);
  _event2.default.down({
    key: 'p',
    once: true,
    callback: function callback() {
      var state = store.state;
      if (state.lock) {
        return;
      }
      var cur = state.cur;
      var isPause = state.pause;
      if (cur !== null) {
        _states2.default.pause(!isPause);
      } else {
        _states2.default.start();
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_pause', false);
  _event2.default.up({
    key: 'p'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = __webpack_require__(4);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(3);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_reset', true);
  if (store.state.lock) {
    return;
  }
  if (store.state.cur !== null) {
    _event2.default.down({
      key: 'r',
      once: true,
      callback: function callback() {
        _states2.default.overStart();
      }
    });
  } else {
    _event2.default.down({
      key: 'r',
      once: true,
      callback: function callback() {
        if (store.state.lock) {
          return;
        }
        _states2.default.start();
      }
    });
  }
};

var up = function up(store) {
  store.commit('key_reset', false);
  _event2.default.up({
    key: 'r'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unit = __webpack_require__(1);

var _event = __webpack_require__(4);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(3);

var _states2 = _interopRequireDefault(_states);

var _const = __webpack_require__(0);

var _music = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_right', true);
  _event2.default.down({
    key: 'right',
    begin: 200,
    interval: 100,
    callback: function callback() {
      var state = store.state;
      if (state.lock) {
        return;
      }
      if (_music.music.move) {
        _music.music.move();
      }
      var cur = state.cur;
      if (cur !== null) {
        if (state.pause) {
          _states2.default.pause(false);
          return;
        }
        var next = cur.right();
        var delay = _const.delays[state.speedRun - 1];
        var timeStamp = void 0;
        if ((0, _unit.want)(next, state.matrix)) {
          next.timeStamp += parseInt(delay, 10);
          store.commit('moveBlock', next);
          timeStamp = next.timeStamp;
        } else {
          cur.timeStamp += parseInt(parseInt(delay, 10) / 1.5, 10);
          store.commit('moveBlock', cur);
          timeStamp = cur.timeStamp;
        }
        var remain = _const.speeds[state.speedRun - 1] - (Date.now() - timeStamp);
        _states2.default.auto(remain);
      } else {
        var speed = state.speedStart;
        speed = speed + 1 > 6 ? 1 : speed + 1;
        store.commit('speedStart', speed);
      }
    }
  });
};

var up = function up(store) {
  store.commit('key_right', false);
  _event2.default.up({
    key: 'right'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unit = __webpack_require__(1);

var _event = __webpack_require__(4);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(3);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_rotate', true);
  if (store.state.cur !== null) {
    _event2.default.down({
      key: 'rotate',
      once: true,
      callback: function callback() {
        var state = store.state;
        if (state.lock) {
          return;
        }
        if (state.pause) {
          _states2.default.pause(false);
        }
        var cur = state.cur;
        if (cur === null) {
          return;
        }
        if (_music.music.rotate) {
          _music.music.rotate();
        }
        var next = cur.rotate();
        if ((0, _unit.want)(next, state.matrix)) {
          store.commit('moveBlock', next);
        }
      }
    });
  } else {
    _event2.default.down({
      key: 'rotate',
      begin: 200,
      interval: 100,
      callback: function callback() {
        if (store.state.lock) {
          return;
        }
        if (_music.music.move) {
          _music.music.move();
        }
        var state = store.state;
        var cur = state.cur;
        if (cur) {
          return;
        }
        var startLines = state.startLines;
        startLines = startLines + 1 > 10 ? 0 : startLines + 1;
        store.commit('startLines', startLines);
      }
    });
  }
};

var up = function up(store) {
  store.commit('key_rotate', false);
  _event2.default.up({
    key: 'rotate'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _event = __webpack_require__(4);

var _event2 = _interopRequireDefault(_event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit('key_music', true);
  if (store.state.lock) {
    return;
  }
  _event2.default.down({
    key: 's',
    once: true,
    callback: function callback() {
      if (store.state.lock) {
        return;
      }
      store.commit('music', !store.state.music);
    }
  });
};

var up = function up(store) {
  store.commit('key_music', false);
  _event2.default.up({
    key: 's'
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(9);

var _stringify2 = _interopRequireDefault(_stringify);

var _unit = __webpack_require__(1);

var _event = __webpack_require__(4);

var _event2 = _interopRequireDefault(_event);

var _states = __webpack_require__(3);

var _states2 = _interopRequireDefault(_states);

var _music = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var down = function down(store) {
  store.commit("key_drop", true);
  _event2.default.down({
    key: "space",
    once: true,
    callback: function callback() {
      var state = store.state;
      if (state.lock) {
        return;
      }
      var cur = state.cur;
      if (cur !== null) {
        if (state.pause) {
          _states2.default.pause(false);
          return;
        }
        if (_music.music.fall) {
          _music.music.fall();
        }
        var index = 0;
        var bottom = cur.fall(index);
        while ((0, _unit.want)(bottom, state.matrix)) {
          bottom = cur.fall(index);
          index++;
        }
        var matrix = JSON.parse((0, _stringify2.default)(state.matrix));
        bottom = cur.fall(index - 2);
        store.commit("moveBlock", bottom);
        var shape = bottom.shape;
        var xy = bottom.xy;
        shape.forEach(function (m, k1) {
          return m.forEach(function (n, k2) {
            if (n && xy[0] + k1 >= 0) {
              var line = matrix[xy[0] + k1];
              line[xy[1] + k2] = 1;
              matrix[xy[0] + k1] = line;
            }
          });
        });
        store.commit("drop", true);
        setTimeout(function () {
          store.commit("drop", false);
        }, 100);
        _states2.default.nextAround(matrix);
      } else {
        _states2.default.start();
      }
    }
  });
};

var up = function up(store) {
  store.commit("key_drop", false);
  _event2.default.up({
    key: "space"
  });
};

exports.default = {
  down: down,
  up: up
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(28);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(44);

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__(8);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(0);

__webpack_require__(43);

var _unit = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _unit.subscribeRecord)(_store2.default);
_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#root',
  render: function render(h) {
    return h(_App2.default);
  },
  store: _store2.default
});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _unit = __webpack_require__(1);

var _block = __webpack_require__(30);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = {
  nextBlock: function nextBlock(state, data) {
    if (!data) {
      data = (0, _unit.getNextType)();
    }
    state.next = data;
  },
  moveBlock: function moveBlock(state, data) {
    state.cur = data.reset === true ? null : new _block2.default(data);
  },
  speedStart: function speedStart(state, data) {
    state.speedStart = data;
  },
  speedRun: function speedRun(state, data) {
    state.speedRun = data;
  },
  startLines: function startLines(state, data) {
    state.startLines = data;
  },
  matrix: function matrix(state, data) {
    state.matrix = data;
  },
  lock: function lock(state, data) {
    state.lock = data;
  },
  clearLines: function clearLines(state, data) {
    state.clearLines = data;
  },
  points: function points(state, data) {
    state.points = data;
  },
  max: function max(state, data) {
    state.max = data;
  },
  reset: function reset(state, data) {
    state.reset = data;
  },
  drop: function drop(state, data) {
    state.drop = data;
  },
  pause: function pause(state, data) {
    state.pause = data;
  },
  music: function music(state, data) {
    state.music = data;
  },
  focus: function focus(state, data) {
    state.focus = data;
  },
  key_drop: function key_drop(state, data) {
    state.keyboard['drop'] = data;
  },
  key_down: function key_down(state, data) {
    state.keyboard['down'] = data;
  },
  key_left: function key_left(state, data) {
    state.keyboard['left'] = data;
  },
  key_right: function key_right(state, data) {
    state.keyboard['right'] = data;
  },
  key_rotate: function key_rotate(state, data) {
    state.keyboard['rotate'] = data;
  },
  key_reset: function key_reset(state, data) {
    state.keyboard['reset'] = data;
  },
  key_music: function key_music(state, data) {
    state.keyboard['music'] = data;
  },
  key_pause: function key_pause(state, data) {
    state.keyboard['pause'] = data;
  }
};
exports.default = mutations;

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(130),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(136),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(137),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(110)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(132),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(135),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(133),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(118)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(139),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(134),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    style: (_vm.size)
  }, [_c('div', {
    staticClass: "rect",
    class: _vm.drop ? 'drop' : ''
  }, [_c('Decorate'), _vm._v(" "), _c('div', {
    staticClass: "screen"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('Matrix', {
    attrs: {
      "propMatrix": _vm.matrix,
      "cur": _vm.cur,
      "reset": _vm.reset
    }
  }), _vm._v(" "), _c('Logo', {
    attrs: {
      "cur": !!_vm.cur,
      "reset": _vm.reset
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('Point', {
    attrs: {
      "cur": !!_vm.cur,
      "max": _vm.max,
      "point": _vm.points
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pContent))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.cur ? _vm.clearLines : _vm.startLines
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.level))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.cur ? _vm.speedRun : _vm.speedStart,
      "length": 1
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.nextText))]), _vm._v(" "), _c('Next', {
    attrs: {
      "data": _vm.next
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('Music', {
    attrs: {
      "data": _vm.music
    }
  }), _vm._v(" "), _c('Pause', {
    attrs: {
      "data": _vm.pause
    }
  }), _vm._v(" "), _c('Number', {
    attrs: {
      "propTime": true
    }
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('Keyboard', {
    attrs: {
      "filling": _vm.filling
    }
  }), _vm._v(" "), _c('Guide')], 1)
},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "decorate"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topBorder"
  }, [_c('span', {
    staticClass: "l mr",
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "l mr"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml",
    staticStyle: {
      "width": "40px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  }), _vm._v(" "), _c('span', {
    staticClass: "r ml"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view l"
  }, [_c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('em'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('b', {
    staticClass: "c"
  })])
}]}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "keyboard",
    style: ('margin-top:' + _vm.fillingNum + 'px')
  }, [_c('vbutton', {
    ref: "dom_rotate",
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 0,
      "left": 374,
      "label": _vm.rotation,
      "arrow": "translate(0, 63px)",
      "position": true,
      "active": _vm.keyboard['rotate']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_down",
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 180,
      "left": 374,
      "label": _vm.labelDown,
      "arrow": "translate(0,-71px) rotate(180deg)",
      "active": _vm.keyboard['down']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_left",
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 90,
      "left": 284,
      "label": _vm.labelLeft,
      "arrow": "translate(60px, -12px) rotate(270deg)",
      "active": _vm.keyboard['left']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_right",
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 90,
      "left": 464,
      "label": _vm.labelRight,
      "arrow": "translate(-60px, -12px) rotate(90deg)",
      "active": _vm.keyboard['right']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_space",
    attrs: {
      "color": "blue",
      "size": "s0",
      "top": 100,
      "left": 52,
      "label": _vm.labelDropSpace,
      "active": _vm.keyboard['drop']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_r",
    attrs: {
      "color": "red",
      "size": "s2",
      "top": 0,
      "left": 196,
      "label": _vm.labelResetR,
      "active": _vm.keyboard['reset']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_s",
    attrs: {
      "color": "green",
      "size": "s2",
      "top": 0,
      "left": 106,
      "label": _vm.labelSoundS,
      "active": _vm.keyboard['music']
    }
  }), _vm._v(" "), _c('vbutton', {
    ref: "dom_p",
    attrs: {
      "color": "green",
      "size": "s2",
      "top": 0,
      "left": 16,
      "label": _vm.labelPauseP,
      "active": _vm.keyboard['pause']
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo",
    style: ('display:' + _vm.display)
  }, [_c('div', {
    staticClass: "bg dragon",
    class: _vm.style
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.titleCenter)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next"
  }, _vm._l((_vm.block), function(item, index) {
    return _c('div', _vm._l((item), function(e, k2) {
      return _c('b', {
        class: e ? 'c' : ''
      })
    }))
  }))
},staticRenderFns: []}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('Number', {
    attrs: {
      "number": _vm.number
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg music",
    class: _vm.data ? '' : 'c'
  })
},staticRenderFns: []}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMobile),
      expression: "!isMobile"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "guide left"
  }, [_c('p', [_c('a', _vm._b({
    attrs: {
      "href": "https://blog.revenuebee.top",
      "rel": "noopener noreferrer",
      "target": "_blank"
    }
  }, 'a', {
    title: _vm.linkTitle
  }), [_vm._v(_vm._s(_vm.blog))])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }, [_vm._v("SPACE")])]), _vm._v(" "), _c('div', {
    staticClass: "guide qr"
  }, [_c('img', _vm._b({
    attrs: {
      "src": _vm.QRSrc
    }
  }, 'img', {
    title: _vm.QRTitle,
    alt: _vm.QRCode
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide right"
  }, [_c('div', {
    staticClass: "up"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(0,-3px) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(-7px,3px) rotate(-90deg) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "down"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(0,9px) rotate(180deg) scale(1,2)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('em', {
    staticStyle: {
      "transform": "translate(7px,3px)rotate(90deg) scale(1,2)"
    }
  })])])
}]}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button",
    class: _vm.color + ' ' + _vm.size,
    style: ('top:' + _vm.top + 'px;' + 'left:' + _vm.left + 'px')
  }, [_c('i', {
    class: {
      'active': _vm.active
    }
  }), _vm._v(" "), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.size === 's1'),
      expression: "size==='s1'"
    }],
    style: ('transform:' + _vm.arrow + ' scale(1,2)')
  }), _vm._v(" "), _c('span', {
    class: _vm.position ? 'position' : ''
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('span', {
      class: 'bg s_' + item
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg pause",
    class: {
      'c': _vm.showPause
    }
  })
},staticRenderFns: []}

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

module.exports = {
	"lang": [
		"cn",
		"en",
		"fr",
		"fa"
	],
	"default": "en",
	"data": {
		"title": {
			"cn": "俄罗斯方块",
			"en": "T E T R I S",
			"fr": "T E T R I S",
			"fa": "خانه سازی"
		},
		"blog": {
			"cn": "蜂王的博客",
			"en": "RevenueBee's blog",
			"fr": "Blog de RevenueBee",
			"fa": "وبلاگ RevenueBee"
		},
		"linkTitle": {
			"cn": "查看源代码",
			"en": "View data source",
			"fr": "Afficher la source des données",
			"fa": "مشاهده سورس پروژه"
		},
		"QRCode": {
			"cn": "二维码",
			"en": "QR code",
			"fr": "QR code",
			"fa": "کیوآر کد"
		},
		"QRNotice": {
			"cn": "扫一扫用手机玩",
			"en": "Scan QR code to play with a mobile phone",
			"fr": "Numérisez le code QR pour jouer avec un téléphone mobile",
			"fa": "اسکن کیوآر کد برای بازی در تلفن همراه"
		},
		"titleCenter": {
			"cn": "俄罗斯方块<br />TETRIS",
			"en": "TETRIS",
			"fr": "TETRIS",
			"fa": "خانه سازی"
		},
		"point": {
			"cn": "得分",
			"en": "Point",
			"fr": "Score",
			"fa": "امتیاز"
		},
		"highestScore": {
			"cn": "最高分",
			"en": "Max",
			"fr": "Max",
			"fa": "حداکثر"
		},
		"lastRound": {
			"cn": "上轮得分",
			"en": "Last Round",
			"fr": "Dernier Tour",
			"fa": "آخرین دور"
		},
		"cleans": {
			"cn": "消除行",
			"en": "Cleans",
			"fr": "Lignes",
			"fa": "پاک کرد"
		},
		"level": {
			"cn": "级别",
			"en": "Level",
			"fr": "Difficulté",
			"fa": "سطح"
		},
		"startLine": {
			"cn": "起始行",
			"en": "Start Line",
			"fr": "Ligne Départ",
			"fa": "خط شروع"
		},
		"next": {
			"cn": "下一个",
			"en": "Next",
			"fr": "Prochain",
			"fa": "بعدی"
		},
		"pause": {
			"cn": "暂停",
			"en": "Pause",
			"fr": "Pause",
			"fa": "مکث"
		},
		"sound": {
			"cn": "音效",
			"en": "Sound",
			"fr": "Sonore",
			"fa": "صدا"
		},
		"reset": {
			"cn": "重玩",
			"en": "Reset",
			"fr": "Réinitialiser",
			"fa": "ریست"
		},
		"rotation": {
			"cn": "旋转",
			"en": "Rotation",
			"fr": "Rotation",
			"fa": "چرخش"
		},
		"left": {
			"cn": "左移",
			"en": "Left",
			"fr": "Gauche",
			"fa": "چپ"
		},
		"right": {
			"cn": "右移",
			"en": "Right",
			"fr": "Droite",
			"fa": "راست"
		},
		"down": {
			"cn": "下移",
			"en": "Down",
			"fr": "Bas",
			"fa": "پایین"
		},
		"drop": {
			"cn": "掉落",
			"en": "Drop",
			"fr": "Tomber",
			"fa": "سقوط"
		}
	}
};

/***/ })
],[65]);


// WEBPACK FOOTER //
// static/js/app.ebe04a649864c7a4d5d3.js